module.exports = {
      id: "forward-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#forward",
      toString: function () {
        return this.url;
      }
    }